import type { ResourceDefinitionType } from "@validereinc/domain";
import { kebabCase } from "es-toolkit/compat";

export const getImportDataActionQueueKey = ({
  resource,
  resourceId,
}: {
  resource: ResourceDefinitionType;
  resourceId?: string;
}) =>
  `queue-import-data-action-${resource.id}-${kebabCase(resource.label.singular)}${
    resourceId ? `-${resourceId}` : ""
  }`;
